import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ToastNotification from "../../../components/Toast";
import { API_USERS_SIGNIN } from "../../../service/url";
import { postApiCall } from "../../../service/httpCall";
import { storeUser } from "../../../utilities/setting";
import { ROUTES } from "../../../utilities/constant";
import { useDispatch } from "react-redux";
import { setUser } from "../../../store/setting/actions";
import auth1 from "../../../assets/images/auth/01.png";
import { Eye, EyeOff } from "lucide-react";
import loginIllustration from "../../../assets/images/auth/logoImage.png";
import "../../../../src/assets/custom/css/SignIn.css";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { toast } from "react-toastify";


const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   if (toastProps) setShowToast(true);
  // }, [toastProps]);

  const validate = () => {
    if (!username.trim()) {
      // setToastProps({ message: "Username required", type: "danger" });
          toast.error("Username required");
      return false;
    }
    if (!password.trim()) {
      // setToastProps({ message: "Password required", type: "danger" });
          toast.error("Password required");
      return false;
    }
    return true;
  };

  const submit = (e) => {
    setButtonDisable(true);
    if (!validate()) {
      setButtonDisable(false);
      return;
    }
    const params = { username, password };
    postApiCall(API_USERS_SIGNIN, params)
      .then((resp) => {
        AsyncStorage.multiRemove(['loginTimestamp', 'idleTimestamp']);
        storeUser(resp, () => {
          dispatch(setUser(resp));
          // setToastProps({ message: "Login successful", type: "success" });
          toast.success("Login Successfully");
          setTimeout(() => navigate(`/${ROUTES.DASHBOARD}`), 1500);
        });
      })
      .catch((err) => {
        setButtonDisable(false);
        // Extract error message from API response
        let errorMessage = 'Login failed';
        if (err?.response?.data?.message) {
          errorMessage = err.response.data.message;
        } else if (err?.message) {
          errorMessage = err.message;
        } else if (typeof err === 'string') {
          errorMessage = err;
        }
        // setToastProps({ message: errorMessage, type: "danger" });
          toast.error(errorMessage);
      });
  };

  return (
    <div className="auth-container signin-container">
      <div className="left-panel">
        <div className="circle"></div>
        <div className="blob"></div>
        <div className="circle2"></div>
        <div className="gradient"></div>
        <div className="overlay"></div>
        <img src={auth1} alt="Auth background" className="bg" />
        <div className="brand">
          <div className="logo">
            <svg width="42" height="42" viewBox="0 0 30 30" fill="none">
              <rect
                x="-0.757"
                y="19.243"
                width="28"
                height="4"
                rx="2"
                transform="rotate(-45 -0.757 19.243)"
                fill="currentColor"
              />
              <rect
                x="7.728"
                y="27.728"
                width="28"
                height="4"
                rx="2"
                transform="rotate(-45 7.728 27.728)"
                fill="currentColor"
              />
              <rect
                x="10.537"
                y="16.395"
                width="16"
                height="4"
                rx="2"
                transform="rotate(45 10.537 16.395)"
                fill="currentColor"
              />
              <rect
                x="10.556"
                y="-0.556"
                width="28"
                height="4"
                rx="2"
                transform="rotate(45 10.556 -0.556)"
                fill="currentColor"
              />
            </svg>
          </div>
          <h1>Cloud Telephony</h1>
          <img
            src={loginIllustration}
            alt="Login visual"
            className="illustration"
          />
        </div>
      </div>

      <div className="right-panel">
        {isMobile && (
          <div style={{ textAlign: "center", marginBottom: "2rem" }}>
            <div className="mobile-logo logo">
              <svg width="42" height="42" viewBox="0 0 30 30" fill="none">
                <rect
                  x="-0.757"
                  y="19.243"
                  width="28"
                  height="4"
                  rx="2"
                  transform="rotate(-45 -0.757 19.243)"
                  fill="currentColor"
                />
                <rect
                  x="7.728"
                  y="27.728"
                  width="28"
                  height="4"
                  rx="2"
                  transform="rotate(-45 7.728 27.728)"
                  fill="currentColor"
                />
                <rect
                  x="10.537"
                  y="16.395"
                  width="16"
                  height="4"
                  rx="2"
                  transform="rotate(45 10.537 16.395)"
                  fill="currentColor"
                />
                <rect
                  x="10.556"
                  y="-0.556"
                  width="28"
                  height="4"
                  rx="2"
                  transform="rotate(45 10.556 -0.556)"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h1 style={{ color: "#020f1aff" }}>Cloud Telephony</h1>
          </div>
        )}

        <div className="formCard">
          <h2 className="title">Welcome Back</h2>
          <p className="subtitle">Sign in to continue</p>

          <div className="form-group">
            <label htmlFor="username" className="label">
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              className="input"
              tabIndex={1}
            />
          </div>

          <div className="form-group">
            <div className="label-row">
              <label htmlFor="password" className="label">
                Password
              </label>
              <Link to="/auth/recoverpw" className="forgot" tabIndex={-1}>
                Forgot Password?
              </Link>
            </div>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="input"
                tabIndex={2}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    submit(e);
                  }
                }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="eye-icon"
                tabIndex={-1}
                style={{ pointerEvents: 'auto' }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
          </div>

          <div className="options">
            <label className="checkbox">
              <input type="checkbox" tabIndex={3} />
              Remember me
            </label>
          </div>

          <button 
            onClick={submit} 
            className="button" 
            disabled={buttonDisable}
            tabIndex={4}
            type="submit"
          >
            {buttonDisable ? <div className="spinner"></div> : "Sign In"}
          </button>
        </div>
      </div>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </div>
  );
};

export default SignIn;
